<template>
  <div class="sidebar">
    <h2>Result</h2>
    <div ref="previewContainer" class="preview">
      <canvas ref="previewCanvas" class="canvas js-canvas-preview"></canvas>
    </div>
    <div class="info">
      <p>Final output size: {{ width }}px by {{ height }}px.</p>
    </div>
    <Download/>
  </div>
</template>

<script>
import canvasPreview from '../controllers/canvasPreview';
import Download from './Download.vue';

export default {
  name: 'Preview',
  components: { Download },
  mounted() {
    canvasPreview.init(this.$refs.previewContainer, this.$refs.previewCanvas);
  },
  computed: {
    width() {
      return this.$store.getters.canvasWidth;
    },
    height() {
      return this.$store.getters.canvasHeight * this.$store.getters.panelCount;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/variables';

  .sidebar {
    display: flex;
    flex-direction: column;

    border: 1px solid #ddd;
    border-radius: 5px;
    width: 312px;
    min-width: 312px;
    height: 100%;
    max-height: 100%;

    margin: $spacing $spacing $spacing 0;
    padding: $spacing;
  }

  .preview {
    width: 100%;
    height: 100%;
    max-height: 100%;
    margin-bottom: $spacing;

    .canvas {
      margin: 0 auto auto auto;
      outline: 1px solid black;
    }
  }
</style>
